export enum NewIconNames {
  Add = 'Add',
  AddChannel = 'AddChannel',
  AdminAccess = 'AdminAccess',
  AppMarket = 'AppMarket',
  Archive = 'Archive',
  Block = 'Block',
  BonusGift = 'BonusGift',
  Chat = 'Chat',
  Check = 'Check',
  ChevronDown = 'ChevronDown',
  ChevronLeft = 'ChevronLeft',
  ChevronLeftLarge = 'ChevronLeftLarge',
  ChevronRight = 'ChevronRight',
  ChevronRightLarge = 'ChevronRightLarge',
  ChevronUp = 'ChevronUp',
  Code = 'Code',
  ColorDrop = 'ColorDrop',
  Date = 'Date',
  Delete = 'Delete',
  Document = 'Document',
  Download = 'Download',
  Duplicate = 'Duplicate',
  Edit = 'Edit',
  Email = 'Email',
  EmailOpen = 'EmailOpen',
  EmptyTrash = 'EmptyTrash',
  ExternalLink = 'ExternalLink',
  Facebook = 'Facebook',
  FatChevronLeft = 'FatChevronLeft',
  FatChevronRight = 'FatChevronRight',
  FoodInStock = 'FoodInStock',
  FoodOutOfStock = 'FoodOutOfStock',
  Gift = 'Gift',
  Globe = 'Globe',
  Google = 'Google',
  Hidden = 'Hidden',
  Hint = 'Hint',
  Home = 'Home',
  Image = 'Image',
  Info = 'Info',
  InfoCircle = 'InfoCircle',
  Languages = 'Languages',
  LayoutGallery = 'LayoutGallery',
  LayoutGalleryWithPanel = 'LayoutGalleryWithPanel',
  LayoutList = 'LayoutList',
  LayoutListWithPanel = 'LayoutListWithPanel',
  Link = 'Link',
  List = 'List',
  LockLocked = 'LockLocked',
  LockUnlocked = 'LockUnlocked',
  Minus = 'Minus',
  More = 'More',
  MoveTo = 'MoveTo',
  Music = 'Music',
  NewFolder = 'NewFolder',
  OpenModal = 'OpenModal',
  Pause = 'Pause',
  Pin = 'Pin',
  Play = 'Play',
  Print = 'Print',
  Promote = 'Promote',
  Refresh = 'Refresh',
  Rename = 'Rename',
  Replace = 'Replace',
  Revert = 'Revert',
  Search = 'Search',
  Settings = 'Settings',
  SortAscending = 'SortAscending',
  SortAZ = 'SortAZ',
  SortDescending = 'SortDescending',
  SortZA = 'SortZA',
  Sound = 'Sound',
  SoundOff = 'SoundOff',
  Star = 'Star',
  StarFilled = 'StarFilled',
  Statistics = 'Statistics',
  StatusAlert = 'StatusAlert',
  StatusComplete = 'StatusComplete',
  Stop = 'Stop',
  StatusAlertFilled = 'StatusAlertFilled',
  Tag = 'Tag',
  Time = 'Time',
  Unlink = 'Unlink',
  Upload = 'Upload',
  User = 'User',
  Users = 'Users',
  VideoCamera = 'VideoCamera',
  Visible = 'Visible',
  X = 'X',
  YandexEn = 'YandexEn',
  YandexRu = 'YandexRu',
}
